import styled from 'styled-components';
import mediaQueries from 'constants/mediaQueries';

import { colorWhite } from 'constants/colors';

const HERO_HEIGHT_DESKTOP = '351px';
const HERO_HEIGHT_MOBILE = '216px';

export const Holder = styled.div<{ bgColor: string; path?: string }>`
  position: relative;
  background-color: ${props => props.bgColor};
  background-image: url(${props => props.path || ''});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  height: ${HERO_HEIGHT_MOBILE};
  z-index: 0;

  ${mediaQueries.desktop} {
    display: block;
    max-height: 480px;
    min-height: 320px;
    height: ${HERO_HEIGHT_DESKTOP};
    width: 100%;
  }
`;

export const ImageMask = styled.div`
  height: ${HERO_HEIGHT_MOBILE};
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  opacity: 1;

  ${mediaQueries.desktop} {
    height: 100%;
  }
`;

export const Content = styled.div`
  background-color: transparent;
  bottom: 100px;
  display: flex;
  height: 160px;
  justify-content: center;
  left: 0;
  position: relative;
  top: 0;
  width: 100%;
  min-height: 100%;

  ${mediaQueries.desktop} {
    height: 100%;
    position: absolute;
  }
`;

export const HeadlineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin: 8px 0;
  margin-top: 0;
  height: ${HERO_HEIGHT_MOBILE};

  ${mediaQueries.desktop} {
    margin: 0;
    height: ${HERO_HEIGHT_DESKTOP};
  }
`;

export const SubHeading = styled.div`
  color: ${colorWhite};
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1.4px;
  line-height: 20px;

  ${mediaQueries.desktop} {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 1.6px;
  }
`;

export const H1 = styled.h1`
  color: ${colorWhite};
  font-size: 24px;
  font-weight: bold;
  line-height: 28px;
  margin: 0;
  overflow: hidden;

  ${mediaQueries.desktop} {
    font-size: 40px;
    line-height: 48px;
    padding-bottom: 24px;
  }
`;
